import { createAsyncThunk } from "@reduxjs/toolkit";
import { addDocument, addSegment, create, deleteDocuments, deleteSegments, getDetail, getDocument, getList, initializeKnowledgeBase, remove, update, updateSegments, uploadFileData } from "services/knowledge.service";


export const getKnowledge = createAsyncThunk("knowledge/getKnowledge", async () => {
  try {
    const response = await getList();
    return response;
  } catch (error) {
    return error;
  }
});

export const getKnowledgeDetail = createAsyncThunk("knowledge/getKnowledgeDetail", async (id: string) => {
  try {
    const response = await getDetail(id);
    return response;
  } catch (error) {
    return error;
  }
});

export const createKnowledge = createAsyncThunk("knowledge/createKnowledge", async (payload: any) => {
  try {
    const response = await create(payload);
    return response;
  } catch (error) {
    return error;
  }
});

export const updateKnowledge = createAsyncThunk("knowledge/updateKnowledge", async ({ id, payload }: { id: string; payload: any }) => {
  try {
    const response = await update(id, payload);
    return response;
  } catch (error) {
    return error;
  }
});

export const deleteKnowledge = createAsyncThunk("knowledge/deleteKnowledge", async (id: string) => {
  try {
    const response = await remove(id);
    // dispatch(getKnowledge());
    return response;
  } catch (error) {
    return error;
  }
});


export const uploadKnowledgeFile = createAsyncThunk("knowledge/uploadKnowledgeFile", async ({ source, file }: { source: string; file: File }) => {
  try {
    const response = await uploadFileData(source, file);
    return response;
  } catch (error) {
    return error;
  }
});

export const initKnowledge = createAsyncThunk("knowledge/initKnowledge", async (payload: any) => {
  try {
    const response = await initializeKnowledgeBase(payload);
    return response;
  } catch (error) {
    return error;
  }
});

export const getDocumentDetail = createAsyncThunk("knowledge/getDocumentDetail", async (id: string) => {
  try {
    const response = await getDocument(id);
    return response;
  } catch (error) {
    return error;
  }
});


export const deleteBulkDocument = createAsyncThunk("knowledge/deleteBulkDocument", async ({ id, documentIds }: { id: string; documentIds: any[] }) => {
  try {
    const response = await deleteDocuments(id, documentIds);
    return response;
  } catch (error) {
    return error;
  }
});

export const deleteBulkSegments = createAsyncThunk("knowledge/deleteBulkSegments", async ({ knowledgeId, documentId, segmentIds }: { knowledgeId: string; documentId: string; segmentIds: any[] }) => {
  try {
    const response = await deleteSegments(knowledgeId, documentId, segmentIds);
    return response;
  } catch (error) {
    return error;
  }
});


export const updateSegment = createAsyncThunk("knowledge/updateSegment", async ({ knowledgeId, documentId, segmentId, payload }: { knowledgeId: string; documentId: string; segmentId: string; payload: any[] }) => {
  try {
    const response = await updateSegments(knowledgeId, documentId, segmentId, payload);
    return response;
  } catch (error) {
    return error;
  }
});

export const addDocumentToKnowledge = createAsyncThunk("knowledge/addDocument", async ({ knowledgeId, payload }: { knowledgeId: string | null; payload: any }) => {
  try {
    const response = await addDocument(knowledgeId, payload);
    return response;
  } catch (error) {
    return error;
  }
});

export const addSegmentToDocument = createAsyncThunk("knowledge/addSegment", async ({ knowledgeId, documentId, payload }: { knowledgeId: string; documentId: string; payload: any }) => {
  try {
    const response = await addSegment(knowledgeId, documentId, payload);
    return response;
  } catch (error) {
    return error;
  }
});
